import React, { useEffect, useState } from "react";
import CardComponent from "@/components/card";
import Container from "@/components/container/Container";
import "@/styles/pages/auth/doRegisteration.scss";
import ButtonComponent from "@/components/button/Button";
import { useDispatch } from "react-redux";
import { setCurrentForm, setModalOpen } from "@/reducers/commonSlice";

const DoRegisteration = () => {
  const dispatch = useDispatch();
  const handleSignUp = () => {
    dispatch(setModalOpen(true));
    dispatch(setCurrentForm("signIn"));
  };
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setIsVisible(true);
    }, 2000);
  }, []);

  return (
    <Container className="doRegisteration-Wrapper">
      <CardComponent className="card">
        <div className="card-wrapper">
          {isVisible ? (
            <>
              <img src="/assets/images/doRegistration.png" />
              <div className="title-h4">Sign In Now!</div>
              <div className="body-b12 sublabel">
                It seems like you haven't signed in yet. Sign in now to view this page.
              </div>
              <ButtonComponent
                label="Click Here to Sign In"
                varient="primary"
                onClick={handleSignUp}
              />
            </>
          ) : (
            <>
              <div style={{ height: "200px" }}></div>
            </>
          )}
        </div>
      </CardComponent>
    </Container>
  );
};

export default DoRegisteration;
